import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChart1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChart1"><Path fillRule="evenodd" clipRule="evenodd" d="M2 3H22V19H16.3257L17.2362 22.1868L15.3132 22.7362L14.2457 19H9.7543L8.6868 22.7362L6.76375 22.1868L7.67427 19H2V3ZM9 12H7V15H9V12ZM13 7V15H11V7H13ZM17 10H15V15H17V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChart1;
